import * as React from "react";

import Svg, { Path } from "react-native-svg";
import { Box } from "../AHTheme/Box";

export const NumberIconSvg = (props: { color?: string }) => {
  return (
    <Svg viewBox="0 0 24 24">
      <Path
        fill={props.color ?? "#FFF"}
        d="M16.023 14.328v1.312h-4.96v-1.312h4.96zM7.59 9.432V8.16h2.217V14H8.383V9.432H7.59z"
      />
    </Svg>
  );
};

export const NumberIcon = (props: { color?: string; absoluteSize: number }) => {
  return (
    <Box
      style={{
        height: props.absoluteSize,
        width: props.absoluteSize,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <NumberIconSvg color={props.color} />
    </Box>
  );
};
